import {ApiError} from '../services/api';

/**
 * Text of the blocking "signed-in user changed" notice. It must not overclaim: a request sent just before the
 * cookie changed may already have been executed (and saved) by the server, so the user is told to check the
 * document list before entering anything again. Only a request the server explicitly refused (ACTOR_MISMATCH)
 * is reported as not saved.
 */
export type SessionNoticeState={rejected:boolean;unverified:boolean};

export const SESSION_NOTICE_TITLE='Signed-in user changed';

export function sessionNoticeLines(state:SessionNoticeState):string[]{
 const lines=[
  'The signed-in user changed in another tab.',
  'Anything submitted just before the change may already have been saved. Check the document list or status before entering it again.',
  'Unsaved entries in this tab were cleared.',
 ];
 if(state.rejected)lines.push('Your last request was rejected by the server because of this change and was NOT saved.');
 if(state.unverified)lines.push('Could not verify your session. Check your connection and retry.');
 return lines;
}

export function sessionNoticeAction(state:SessionNoticeState,busy:boolean):string{
 if(busy)return 'Checking…';
 return state.unverified?'Retry':'Continue as the current user';
}

/**
 * What a failed /auth/me re-check means. Only a confirmed 401 (no valid session) returns the tab to Login; a
 * network error, a 5xx or any other failure means the session could not be verified, which must never be
 * treated as a sign-out (the cookie may still belong to someone else, so the notice stays up).
 */
export type RecheckFailure='signed-out'|'unverified';
export function classifyRecheckFailure(error:unknown):RecheckFailure{
 return error instanceof ApiError&&error.status===401?'signed-out':'unverified';
}
